import i18next from "i18next";
import { useState } from "react";
import { PartnersSwiperComponent } from "../info/PartnersComponent/PartnersSwiperComponent/PartnersSwiperComponent";
import { VisaFreeComponent } from "../info/VisaFreeComponent";
import { ContainerComponent } from "../ui";
import { Wrapper } from "./Home.style";

const Home = () => {
  const [airport, setAirport] = useState("9600397");
  const { t } = i18next;

  return (
    <ContainerComponent fixed style={{ width: "100%" }}>
      <Wrapper>
        <VisaFreeComponent />
        <PartnersSwiperComponent />
      </Wrapper>
    </ContainerComponent>
  );
};

export default Home;
